import {Shift} from '@domain/calendar/shift/shift';
import {PresetColors} from '@vdw/angular-component-library';

export class ShiftStubFactory {
  public static getRandomShift(id: number = 1): Shift {
    return new Shift(id, `Shift ${id}`, PresetColors.AQUA);
  }
}
